import initialAddons from "@/data/forms/addons.json";
import { Addon } from "@/templates/types";

export const buildAddons = (addons: Addon[], siteAddons?: Addon[] | null) => {
  if (addons && Array.isArray(addons)) {
    // Addons checked by default come from the site-info `checked` flag (PASGF-2744)
    const checkedByIdentifier = new Set(
      (siteAddons ?? [])
        .filter((siteAddon) => siteAddon?.checked === true)
        .map((siteAddon) => siteAddon.identifier)
    );

    const builtAddons = addons.map((addon) => ({
      ...buildAddon(addon),
      value: checkedByIdentifier.has(addon.identifier) ? "1" : "0",
    }));

    return builtAddons;
  } else {
    console.log("[buildAddons] No addons or invalid addons array");
    return [];
  }
};

const buildAddon = (addon: Addon) => {
  const addonFromJson = initialAddons[addon.identifier as keyof typeof initialAddons];

  return {
    ...addonFromJson,
    ...addon,
    price: `$${addon.amount.toFixed(2)}`,
  };
};

export const buildAddonsFromIdentifiers = (
  addonIdentifiers: {
    amount: number;
    identifier: "discount" | "insurance" | "card" | "priority" | "tsa_precheck";
  }[]
) => {
  if (addonIdentifiers && Array.isArray(addonIdentifiers)) {
    const addonsOutput = addonIdentifiers.map(({ identifier, amount }) => {
      const addon = initialAddons[identifier as keyof typeof initialAddons];
      const addonToReturn: any = buildAddon({
        ...addon,
        identifier: identifier,
        amount: amount,
        id: `addon-${identifier}`,
        value: "1", // Set to "1" to indicate the addon is selected from application identifiers
      });

      return addonToReturn;
    });

    return addonsOutput;
  } else {
    return [];
  }
};
/**
 *
 * @param {Number} price
 * @param {Array} addons
 */

export const calculateTotal = (price: number, addons: Addon[], fees?: number | undefined) => {
  let result = fees ? +price + +fees : +price;

  if (addons && Array.isArray(addons)) {
    addons.forEach((addon) => (addon.value === "1" ? (result += +addon.amount) : null));
  }

  return result;
};
